import { useState, type ImgHTMLAttributes, type ReactNode } from "react";
import { ENVIRONMENT_DELIVERY } from "../generated/environment-delivery.generated.js";

/** Same crop/geometry as the source PNG. Failed format/variant falls back once. */
export function ResponsiveSceneImage({ delivery = "optimized", ...props }: ImgHTMLAttributes<HTMLImageElement> & { readonly delivery?: "original" | "optimized" }): ReactNode {
  const [failedSource, setFailedSource] = useState<string | undefined>();
  const variants = delivery === "original" || props.src === undefined || failedSource === props.src ? undefined : ENVIRONMENT_DELIVERY[props.src];
  return <img {...props} decoding="async"
    srcSet={variants?.map((variant) => `${variant.href} ${String(variant.width)}w`).join(", ")}
    sizes={props.sizes ?? "100vw"}
    onError={(event) => {
      if (variants !== undefined) setFailedSource(props.src);
      else props.onError?.(event);
    }} />;
}

/** SVG images cannot use srcset. Keep the original href on each node for error recovery. */
export function optimizeSvgDelivery(svg: string, targetWidth: number): string {
  return svg.replace(/<image\b([^>]*?)href="(\/plates\/[a-f0-9]{64}\.png)"/gu, (match: string, attrs: string, href: string) => {
    const variants = ENVIRONMENT_DELIVERY[href];
    const chosen = variants?.find((v) => v.width >= targetWidth) ?? variants?.at(-1);
    return chosen === undefined ? match : `<image${attrs}data-png-fallback="${href}" href="${chosen.href}"`;
  });
}
